import React, { useMemo, useRef } from 'react';
import PrivateRoute from "@common/components/route/PrivateRoute";
import { NavLink, Switch, useParams } from 'react-router-dom';
import { CLUB_MEMBERS_ROUTER } from '@icoach/router/routerPath';
import { GiftProvider } from '@icoach/gift/components/GiftContext';
import GiftDialogBox from '@icoach/gift/dialog/GiftDialogBox';
import GiftPage from '@icoach/gift/GiftPage';
import GiftDispatchRecordPage from '@icoach/gift/GiftDispatchRecordPage';
import GiftDispatchMetricsPage from '@icoach/gift/GiftDispatchMetricsPage';
import TabsCardLayout from '@icoach/components/layout/TabsCardLayout';
import { isFunction } from '@util/utils';

const tabContentType = {
	overview: 'overview',
	dispatchRecord: 'dispatch-record',
	dispatchMetrics: 'dispatch-metrics'
};

const GiftManagementPage = props => {
	const { subTabs } = useParams();
	const dialogRef = useRef(null);
	const refreshRef = useRef(null);

	const tabsData = useMemo(
		() => {
			return [
				{
					label: '贈品總覽',
					value: tabContentType.overview,
					component: NavLink,
					to: CLUB_MEMBERS_ROUTER.GIFT.GET_TABS_PATH('overview')
				},
				{
					label: '發送紀錄',
					value: tabContentType.dispatchRecord,
					component: NavLink,
					to: CLUB_MEMBERS_ROUTER.GIFT.GET_TABS_PATH('dispatch-record')
				},
				{
					label: '贈送統計',
					value: tabContentType.dispatchMetrics,
					component: NavLink,
					to: CLUB_MEMBERS_ROUTER.GIFT.GET_TABS_PATH('dispatch-metrics')
				}
			];
		},
		// eslint-disable-next-line
		[]
	);

	const actionsData = useMemo(
		() => {
			return [
				{
					label: '新增贈品',
					onClick: () => dialogRef.current && dialogRef.current.openGiftDialog({}, refreshRef.current)
				},
				{
					label: '贈品發送',
					onClick: () => dialogRef.current && dialogRef.current.openGiftDispatchDialog({}, refreshRef.current)
				}
			];
		},
		// eslint-disable-next-line
		[]
	);

	const childContext = {
		refresh: () => isFunction(refreshRef.current) && refreshRef.current(),
		setRefresh: fn => (refreshRef.current = fn),
		dialogRef: dialogRef
	};

	return (
		<GiftProvider value={childContext}>
			<TabsCardLayout tabs={tabsData} activeTab={subTabs} actions={actionsData} tabsContent={{ className: 'py-3 px-4' }}>
				<Switch>
					<PrivateRoute exact path={CLUB_MEMBERS_ROUTER.GIFT.GET_TABS_PATH('overview')} as={GiftPage} />
					<PrivateRoute exact path={CLUB_MEMBERS_ROUTER.GIFT.GET_TABS_PATH('dispatch-metrics')} as={GiftDispatchMetricsPage} />
					<PrivateRoute exact path={CLUB_MEMBERS_ROUTER.GIFT.GET_TABS_PATH('dispatch-record')} as={GiftDispatchRecordPage} />
				</Switch>
				<GiftDialogBox ref={dialogRef} />
			</TabsCardLayout>
		</GiftProvider>
	);
};

export default GiftManagementPage;
